module.exports = __webpack_public_path__ + "static/media/ok.e7ff05c9.svg";